import { Container, interfaces } from 'inversify';
import 'reflect-metadata';
import { makeFluentProvideDecorator } from 'inversify-binding-decorators';
import getDecorators from 'inversify-inject-decorators';

export const container = new Container();

const provide = makeFluentProvideDecorator(container);

// tslint:disable-next-line:no-any
export function provideInstance(identifier: string | symbol | interfaces.Newable<any>) {
  return provide(identifier).done();
}

// tslint:disable-next-line:no-any
export function provideSingleton(identifier: string | symbol | interfaces.Newable<any>) {
  return provide(identifier).inSingletonScope().done();
}

export const inject = getDecorators(container).lazyInject;

/**
 * Decorator um Klassenmethoden an Klassenkontext zu binden
 * macht Konstrukt this.methodenname = this.mehtodenname.bind(this) obsolet
 */
export function bind<T extends Function>(target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<T>): TypedPropertyDescriptor<T> | void {
  if (!descriptor || (typeof descriptor.value !== 'function')) {
    throw new TypeError(`Only functions can be decorated with @bind. <${propertyKey}> is not a function!`);
  }

  return {
    configurable: true,
    get(this: T): T {
      const bound: T = descriptor.value!.bind(this);
      Object.defineProperty(this, propertyKey, {
        value: bound,
        configurable: true,
        writable: true
      });
      return bound;
    }
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/decorators.ts